import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { IonHeader, IonToolbar, IonTitle, IonContent, IonCard } from '@ionic/angular'
import { Router } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { StateService } from '../../services/state.service'
import { FirebaseAnalyticsService } from '../../services/firebase-analytics.service'
import { AnalyticsEvents } from '../../models/analytics-events'

@Component({
  selector: 'app-intro-page',
  templateUrl: './intro-page.component.html',
  styleUrl: './intro-page.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonHeader, IonToolbar, IonTitle, IonContent, IonCard, TranslatePipe],
})
export class IntroPageComponent {
  private router = inject(Router)
  private stateService = inject(StateService)
  private firebaseAnalyticsService = inject(FirebaseAnalyticsService)

  selectType(type: 'pre-existing' | 'gestational') {
    this.stateService.setTargetGroup(type)
    const eventName =
      type === 'gestational' ? AnalyticsEvents.TARGET_GROUP_GESTATIONAL : AnalyticsEvents.TARGET_GROUP_PRE_EXISTING
    this.firebaseAnalyticsService.trackEvent(eventName, {})
    this.router.navigate(['/'])
  }
}
